import { render, staticRenderFns } from "./MergeCases.vue?vue&type=template&id=86a0d76e&"
import script from "./MergeCases.vue?vue&type=script&lang=js&"
export * from "./MergeCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports